import { ILoginPage, IReportPage, IStartPage } from "@/contentful/models";

export default class AppStorage {
  contentfulSpace = "bkag3sdu54rc";
  contentfulAccessToken = "bmE7G6KDFFCuBuPte7pYjc36KUbAr1nI_4XpNKAu_U8";
  startPage: IStartPage | null = null;
  reportPage: IReportPage[] = [];
  loginPage: ILoginPage | null = null;
}
